import { AdSlot } from "react-dfp";

const BlockAdSlot = () => (
  <div id="block-ad" className="flex justify-center">
    <AdSlot
      slotId="block-ad"
      sizes={[[300, 250]]}
      sizeMapping={[{ viewport: [0, 0], sizes: [[300, 250]] }]}
      adUnit="ROS_300x250"
    />
  </div>
);

export default BlockAdSlot;
